/**
 * Google maps API loader
 *
 * @package
 */

/**
 * External dependencies
 */
import { Loader as MapLoader } from '@googlemaps/js-api-loader';

/**
 * Internal dependencies
 */
import getkey from './getkey';

/**
 * The Google Maps API loader
 *
 * @member MapLoader|null
 */
let maploader: MapLoader | null = null;

const mapsapi = () => {
	if ( maploader ) {
		// Map loader already exists, return it as a promise
		return Promise.resolve( maploader );
	}

	/**
	 * Get the Google map API key
	 *
	 * @member	{string}	key	The API key
	 */
	return getkey().then( ( key ) => {
		/**
		 * Create the map loader
		 *
		 * @member	{MapLoader}	maploader	The map loader
		 */
		maploader = new MapLoader( {
			apiKey: key,
			version: 'weekly',
		} );

		return maploader;
	} );
};

export default mapsapi;
